import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteVendorCreationPopupContent', {
    popupTitle: 'New Vendor',
    duplicatedSubsidiary: 'Subsidiary in table should be unique.',
    requiredField: 'Field is required',
    requiredPrimarySubsidiaryTaxCode: 'Tax code for primary subsidiary is required',
    invalidUrl: 'Invalid URL',
});
